export const config = {
  appName: 'Vibelin',
  appSubtitle: 'Console',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  authStorageKey: 'vibelin.console.auth',
  /** Google OAuth client id for this app. Blank hides Google sign-in. */
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '',
};
